// extracted by mini-css-extract-plugin
export default {"tooltip":"ES-z","arrow":"FS-z"};